import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-index",
  "use": "icon-index-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-index\"><defs><style>#icon-index .cls-1{ }</style></defs><title>我的首页</title><path class=\"cls-1\" d=\"M8.88,1.13a1.17,1.17,0,0,0-1.63,0L.64,7.41a.63.63,0,0,0-.05.87.63.63,0,0,0,.87.05l.1-.11v6.55A1.16,1.16,0,0,0,2.73,16h3.5V12.32a.86.86,0,0,1,.86-.86H8.76a.9.9,0,0,1,.61.25.86.86,0,0,1,.25.61V16h3.63a1.22,1.22,0,0,0,.87-.32,1.18,1.18,0,0,0,.36-.85V8.3a.61.61,0,0,0,.59.14A.57.57,0,0,0,15.48,8a.61.61,0,0,0-.17-.59Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol